import React from "react";
import HomeBanner from "../../components/sections/HomeBanner/HomeBanner";
import OffersSection from "../../components/sections/OffersSection/OffersSection";
import VehicleSection from "../../components/sections/VehicleSection/VehicleSection";
import HomeHighlightSectionOne from "../../components/sections/HomeHighlightSectionOne/HomeHighlightSectionOne";
import HomeFeaturesSection from "../../components/sections/HomeFeatures/HomeFeaturesSection/HomeFeaturesSection";
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";
import NewsSection from "../../components/sections/NewsSection/NewsSection";

export default function Home() {
    return (
        <>
            <HomeBanner />
            {/* <OffersSection /> */}
            <VehicleSection />
            <HomeHighlightSectionOne />
            <HomeFeaturesSection />
            <NewsSection/>
            <AftersalesSupportSection />
        </>
    );
}
